<script>
import { LabeledInput } from '@components/Form/LabeledInput';
import { Checkbox } from '@components/Form/Checkbox';

import { mapGetters } from 'vuex';

export default {
  components: { LabeledInput, Checkbox },
  props:      {
    // volumeAttributes object
    value: {
      type:    Object,
      default: () => {
        return {};
      }
    },
    mode: {
      type:    String,
      default: 'create'
    }
  },

  computed: { ...mapGetters({ t: 'i18n/t' }) }
};
</script>

<template>
  <div>
    <div class="row mb-10">
      <div class="col span-4">
        <LabeledInput
          v-model="value.name"
          :required="true"
          :mode="mode"
          :label="t('workload.storage.volumeName')"
        />
      </div>
      <div class="col span-4">
        <Checkbox
          v-model="value.awsElasticBlockStore.readOnly"
          :mode="mode"
          :label="t('workload.storage.readOnly')"
        />
      </div>
    </div>
    <div class="row mb-10">
      <div class="col span-4">
        <LabeledInput
          v-model="value.awsElasticBlockStore.volumeID"
          :required="true"
          :mode="mode"
          :label="t('workload.storage.csi.volumeID')"
        />
      </div>
      <div class="col span-4">
        <LabeledInput
          v-model.number="value.awsElasticBlockStore.partition"
          :mode="mode"
          :label="t('workload.storage.csi.partition')"
        />
      </div>
      <div class="col span-4">
        <LabeledInput
          v-model="value.awsElasticBlockStore.fsType"
          :mode="mode"
          :label="t('workload.storage.csi.fsType')"
        />
      </div>
    </div>
  </div>
</template>
